import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getPractice } from "./services/airtable";

export function usePractice() {
  const { slug } = useParams();

  const {
    // isPending stays true until the first result arrives. isLoading is only
    // true while a request is in flight, so a finished failure leaves data
    // undefined with isLoading already false.
    isPending: isLoadingPractice,
    data: practice,
    error,
  } = useQuery({
    queryKey: ["practice", slug],
    queryFn: () => {
      if (!slug) {
        return null;
      }
      return getPractice(slug);
    },
    enabled: !!slug,
  });

  return { isLoadingPractice, practice, error };
}
